var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("failedActivations.searchTab"),
                name: "search",
              },
            },
            [
              _c(
                "div",
                { staticClass: "filters" },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px", "margin-right": "10px" },
                    attrs: {
                      placeholder: "Search by Name, Phone, Serial Number...",
                      clearable: "",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleSearch.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.searchQuery,
                      callback: function ($$v) {
                        _vm.searchQuery = $$v
                      },
                      expression: "searchQuery",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v(" Search ")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { "margin-top": "20px" },
                  attrs: { data: _vm.activations, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "firstName",
                      label: "First Name",
                      width: "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "lastName",
                      label: "Last Name",
                      width: "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "phoneNumber",
                      label: "Phone",
                      width: "170",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "email", label: "Email", width: "250" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "caneSerialNumber",
                      label: "Serial Number",
                      width: "200",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "activationCode",
                      label: "Activation Code",
                      width: "140",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "address", label: "Address", width: "150" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "isActive",
                      label: "Is Active",
                      width: "70",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: row.isActive ? "success" : "danger",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.isActive ? "Active" : "Inactive"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Actions", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showDetails(row.id)
                                  },
                                },
                              },
                              [_vm._v("Details")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "pagination-wrapper",
                  staticStyle: {
                    "margin-top": "20px",
                    display: "flex",
                    "justify-content": "flex-end",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.total,
                      "page-size": _vm.pageSize,
                      "page-sizes": [10, 20, 50, 100],
                      "current-page": _vm.currentPage,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handlePageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { name: "failed" } },
            [
              _c(
                "span",
                { attrs: { slot: "label" }, slot: "label" },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("failedActivations.tabLabel")) + " "
                  ),
                  _vm.failedTotal > 0
                    ? _c("el-badge", {
                        staticStyle: { "margin-left": "6px" },
                        attrs: { value: _vm.failedTotal, type: "danger" },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    margin: "10px 0",
                    color: "#909399",
                    "font-size": "13px",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("failedActivations.description")) + " "
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "10px",
                    display: "flex",
                    gap: "10px",
                    "align-items": "center",
                    "flex-wrap": "wrap",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      size: "small",
                      clearable: "",
                      placeholder: _vm.$t(
                        "failedActivations.searchPlaceholder"
                      ),
                    },
                    on: { clear: _vm.handleFailedSearchClear },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleFailedSearch.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.failedSearch,
                      callback: function ($$v) {
                        _vm.failedSearch = $$v
                      },
                      expression: "failedSearch",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.handleFailedSearch },
                    },
                    [_vm._v(_vm._s(_vm.$t("failedActivations.search")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh" },
                      on: { click: _vm.fetchFailed },
                    },
                    [_vm._v(_vm._s(_vm.$t("failedActivations.refresh")))]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingFailed,
                      expression: "loadingFailed",
                    },
                  ],
                  attrs: {
                    data: _vm.failedActivations,
                    border: "",
                    size: "mini",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "firstName",
                      label: _vm.$t("failedActivations.firstName"),
                      width: "130",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "lastName",
                      label: _vm.$t("failedActivations.lastName"),
                      width: "130",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "email",
                      label: _vm.$t("failedActivations.email"),
                      width: "230",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "serialNumber",
                      label: _vm.$t("failedActivations.caneSerial"),
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "productType",
                      label: _vm.$t("failedActivations.type"),
                      width: "70",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("failedActivations.issue"),
                      width: "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.deviceMissing
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "danger", size: "mini" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "failedActivations.noDeviceRecord"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : !row.deviceOwnerId
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "warning", size: "mini" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("failedActivations.unowned")
                                      )
                                    ),
                                  ]
                                )
                              : _c(
                                  "el-tag",
                                  { attrs: { type: "info", size: "mini" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "failedActivations.boundToAnotherUser"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "deviceOwnerEmail",
                      label: _vm.$t("failedActivations.deviceOwner"),
                      width: "220",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_vm._v(_vm._s(row.deviceOwnerEmail || "-"))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("failedActivations.lostPermanentFeatures"),
                      width: "160",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.lostPermanentFeatures > 0
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "danger", size: "mini" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$tc(
                                            "failedActivations.featureCount",
                                            row.lostPermanentFeatures,
                                            { n: row.lostPermanentFeatures }
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("failedActivations.activation"),
                      width: "160",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(_vm._s(_vm.formatDate(row.completedAt))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("failedActivations.action"),
                      width: "200",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm.isPlaceholderSerial(row.serialNumber)
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.$t(
                                        "failedActivations.brokenSerialTooltip"
                                      ),
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "failedActivations.brokenSerial"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : !row.deviceOwnerId
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "primary",
                                      loading:
                                        _vm.bindingKey ===
                                        row.serialNumber + ":" + row.userId,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.bindRow(row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("failedActivations.bindAndGrant")
                                      )
                                    ),
                                  ]
                                )
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("template", { slot: "empty" }, [
                    _vm._v(_vm._s(_vm.$t("failedActivations.empty"))),
                  ]),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "15px", "text-align": "right" },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, sizes, prev, pager, next",
                      total: _vm.failedTotal,
                      "page-size": _vm.failedPageSize,
                      "page-sizes": [20, 50, 100, 200, 500],
                      "current-page": _vm.failedPage,
                    },
                    on: {
                      "size-change": _vm.handleFailedPageSizeChange,
                      "current-change": _vm.handleFailedPageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Activation Versions",
            visible: _vm.detailsDialogVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailsDialogVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.detailsDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingDetails,
                  expression: "loadingDetails",
                },
              ],
              attrs: { data: _vm.activationVersions, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "mac", label: "MAC Address", width: "200" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "mainAppVersion",
                  label: "Main App Version",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "wirelessVersion",
                  label: "Wireless Version",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "fusVersion",
                  label: "FUS Version",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "appVersion",
                  label: "App Version",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "createdAt", label: "Created At", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.formatDate(row.createdAt)) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }